import { Action, createReducer, on } from '@ngrx/store';
import { loadPharmacyError, setPharmacy } from '../actions/pharmacy.actions';
import { PharmacyState } from '../state/pharmacy.state';

export const initialPharmacyState: PharmacyState = {
  pharmacy: null,
};

const _pharmacyReducer = createReducer(
  initialPharmacyState,
  on(setPharmacy, (state, { pharmacy }) => ({ ...state, pharmacy })),
  on(loadPharmacyError, (state) => ({ ...state, pharmacy: null }))
);

export function pharmacyReducer(state: PharmacyState | undefined, action: Action): PharmacyState {
  return _pharmacyReducer(state, action);
}
